// eslint-disable-next-line prefer-spread
export default (data: number[]) => Math.max.apply(Math, data)
